(function () {
var previewData = {
  "mousepads:type:control": {
    kicker: "Glide Type",
    title: "Control",
    copy: "More stopping power and precision. Best for tac FPS, lower sens, and players who value consistency.",
    meter: 28,
    scaleLeft: "Control",
    scaleRight: "Speed",
    meta: ["High control", "Tac FPS", "Stable aim"],
    bestFor: ["VALORANT", "CS2", "Precision"]
  },

  "mousepads:type:speed": {
    kicker: "Glide Type",
    title: "Speed",
    copy: "Faster glide with less resistance. Best for tracking-heavy aim, fast corrections, and higher tempo play.",
    meter: 82,
    scaleLeft: "Control",
    scaleRight: "Speed",
    meta: ["Fast glide", "Tracking", "Low friction"],
    bestFor: ["Tracking", "Apex", "Fast aim"]
  },

  "mousepads:type:balanced": {
    kicker: "Glide Type",
    title: "Balanced",
    copy: "A middle-ground feel with usable speed and reliable stopping power. Good first choice for most players.",
    meter: 55,
    scaleLeft: "Control",
    scaleRight: "Speed",
    meta: ["Safe pick", "Mixed games", "Versatile"],
    bestFor: ["Mixed games", "Safe pick", "All-round"]
  },

  "mousepads:material:glass": {
    kicker: "Surface Material",
    title: "Glass",
    copy: "Very fast, low-friction surface with a harder feel. Great for speed, but less forgiving than cloth.",
    meter: 8,
    scaleLeft: "Smooth",
    scaleRight: "Textured",
    meta: ["Very fast", "Hard surface", "Durable"],
    bestFor: ["Speed", "Tracking", "Low friction"]
  },

  "mousepads:material:cloth": {
    kicker: "Surface Material",
    title: "Cloth",
    copy: "The most familiar surface type. Usually quieter, more controlled, and easier to adapt to.",
    meter: 42,
    scaleLeft: "Smooth",
    scaleRight: "Textured",
    meta: ["Popular", "Comfortable", "Controlled"],
    bestFor: ["Control", "Comfort", "Everyday use"]
  },

    "mousepads:material:cordura": {
    kicker: "Surface Material",
    title: "Cordura",
    copy: "A tougher woven surface with a faster-than-cloth feel. More textured than glass, but not rough.",
    meter: 36,
    scaleLeft: "Smooth",
    scaleRight: "Textured",
    meta: ["Woven feel", "Durable", "Faster cloth"],
    bestFor: ["Durability", "Hybrid feel", "Faster cloth"]
    },

  "mousepads:size:small": {
    kicker: "Mousepad Size",
    title: "Small",
    copy: "Compact pad size for limited desk space, high sensitivity, or simple keyboard-and-mouse setups.",
    meter: 18,
    scaleLeft: "Compact",
    scaleRight: "Large",
    meta: ["Compact", "High sens", "Desk saving"],
    bestFor: ["High sens", "Small desks", "Compact setups"]
  },

  "mousepads:size:medium": {
    kicker: "Mousepad Size",
    title: "Medium",
    copy: "A balanced size for tighter setups or higher sensitivity players who do not need full-arm movement space.",
    meter: 38,
    scaleLeft: "Compact",
    scaleRight: "Large",
    meta: ["Balanced size", "Higher sens", "Tidy setup"],
    bestFor: ["Higher sens", "Tidy setups", "Casual FPS"]
  },

  "mousepads:size:large": {
    kicker: "Mousepad Size",
    title: "Large",
    copy: "A practical size for most players. Gives more room than standard pads without taking over the whole desk.",
    meter: 52,
    scaleLeft: "Compact",
    scaleRight: "Large",
    meta: ["Practical", "Most setups", "Comfortable"],
    bestFor: ["Most players", "FPS", "Balanced space"]
  },

  "mousepads:size:xl": {
    kicker: "Mousepad Size",
    title: "XL",
    copy: "A strong all-round size for most setups. Enough room for low-to-medium sensitivity without dominating the desk.",
    meter: 68,
    scaleLeft: "Compact",
    scaleRight: "Large",
    meta: ["Popular size", "Good space", "Safe choice"],
    bestFor: ["Low sens", "Arm aim", "Competitive FPS"]
  },

  "mousepads:firmness:extra-soft": {
    kicker: "Base Firmness",
    title: "Extra Soft",
    copy: "A very plush base with more pressure control. Best if you like comfort and extra stopping power from pressing into the pad.",
    meter: 24,
    scaleLeft: "Soft",
    scaleRight: "Firm",
    meta: ["Very plush", "More control", "Comfort"],
    bestFor: ["Comfort", "Pressure control", "Stopping power"]
  },

  "mousepads:firmness:soft": {
    kicker: "Base Firmness",
    title: "Soft",
    copy: "Adds comfort and slightly more stopping power when pressing into the pad. Popular for controlled aim.",
    meter: 36,
    scaleLeft: "Soft",
    scaleRight: "Firm",
    meta: ["Comfort", "Control", "Forgiving"],
    bestFor: ["Control", "Comfort", "Forgiving aim"]
  },

    "mousepads:firmness:mid": {
    kicker: "Base Firmness",
    title: "Mid",
    copy: "A balanced base firmness with less sink than soft pads but more comfort than hard bases.",
    meter: 50,
    scaleLeft: "Soft",
    scaleRight: "Firm",
    meta: ["Balanced", "Consistent", "Stable glide"],
    bestFor: ["Consistency", "Balanced feel", "Most players"]
    },

  "mousepads:firmness:hard": {
    kicker: "Base Firmness",
    title: "Hard",
    copy: "A dense base with minimal give. Best for players who want consistent speed and very little pressure-based slowdown.",
    meter: 82,
    scaleLeft: "Soft",
    scaleRight: "Firm",
    meta: ["Firm feel", "Consistent", "Fast"],
    bestFor: ["Speed", "Low pressure", "Consistency"]
  },

"mice:connectivity:wired": {
  kicker: "Mouse Connectivity",
  title: "Wired",
  copy: "Lowest latency with no charging required. Preferred by players who want absolute consistency.",
  meter: 82,
  scaleLeft: "Freedom",
  scaleRight: "Consistency",
  meta: ["No charging", "Consistent", "Competitive"],
  bestFor: ["Esports", "Consistency", "No battery"]
},

"mice:connectivity:wireless": {
  kicker: "Mouse Connectivity",
  title: "Wireless",
  copy: "Modern wireless mice offer excellent latency with more freedom of movement and cleaner setups.",
  meter: 34,
  scaleLeft: "Freedom",
  scaleRight: "Consistency",
  meta: ["Cable-free", "Clean setup", "Modern tech"],
  bestFor: ["Freedom", "Comfort", "Everyday gaming"]
},

"mice:connectivity:4k": {
  kicker: "Polling Rate",
  title: "4K+ Polling",
  copy: "Higher polling rates can improve motion responsiveness and cursor smoothness on high refresh-rate displays.",
  meter: 92,
  scaleLeft: "Standard",
  scaleRight: "Advanced",
  meta: ["High polling", "Low latency", "Smoother tracking"],
  bestFor: ["240Hz+", "Competitive", "Tracking aim"]
},

"mice:weight:ultralight-70g": {
  kicker: "Mouse Weight",
  title: "Ultralight",
  copy: "Designed for faster flicks and lower fatigue. Popular for competitive FPS and fast aim styles.",
  meter: 8,
  scaleLeft: "Light",
  scaleRight: "Heavy",
  meta: ["Fast flicks", "Low fatigue", "Competitive"],
  bestFor: ["FPS", "Fast aim", "Low sensitivity"]
},

"mice:weight:light-71-to-90g": {
  kicker: "Mouse Weight",
  title: "Light",
  copy: "A balanced lightweight feel that stays agile without becoming too floaty or unstable.",
  meter: 32,
  scaleLeft: "Light",
  scaleRight: "Heavy",
  meta: ["Balanced", "Agile", "Comfortable"],
  bestFor: ["Most players", "Balanced aim", "All-round"]
},

"mice:weight:medium-91-to-120g": {
  kicker: "Mouse Weight",
  title: "Medium Weight",
  copy: "Adds more stability and controlled movement, especially for slower or more deliberate aim styles.",
  meter: 62,
  scaleLeft: "Light",
  scaleRight: "Heavy",
  meta: ["Stable", "Controlled", "Traditional feel"],
  bestFor: ["Control", "Steady aim", "General gaming"]
},

"mice:weight:heavy-121g": {
  kicker: "Mouse Weight",
  title: "Heavy",
  copy: "Heavier mice can feel more planted and stable, though they require more effort for rapid movement.",
  meter: 88,
  scaleLeft: "Light",
  scaleRight: "Heavy",
  meta: ["Stable feel", "More resistance", "Deliberate"],
  bestFor: ["Control", "Relaxed aim", "Stability"]
},

"mice:grip-style:palm": {
  kicker: "Grip Style",
  title: "Palm Grip",
  copy: "Full-hand contact with the mouse for comfort, stability and smoother long-session control.",
  meter: 20,
  scaleLeft: "Stability",
  scaleRight: "Agility",
  meta: ["Comfort", "Stable", "Relaxed"],
  bestFor: ["Comfort", "Tracking", "Long sessions"]
},

"mice:grip-style:claw": {
  kicker: "Grip Style",
  title: "Claw Grip",
  copy: "A hybrid grip style combining some palm support with raised fingers for fast clicks and reactive movement.",
  meter: 62,
  scaleLeft: "Stability",
  scaleRight: "Agility",
  meta: ["Reactive", "Popular", "Fast clicks"],
  bestFor: ["FPS", "Fast reactions", "Hybrid grip"]
},

"mice:grip-style:fingertip": {
  kicker: "Grip Style",
  title: "Fingertip Grip",
  copy: "Minimal palm contact for maximum agility and fast micro-adjustments using fingertip control.",
  meter: 92,
  scaleLeft: "Stability",
  scaleRight: "Agility",
  meta: ["Agile", "Micro-adjustments", "Light feel"],
  bestFor: ["Agility", "Fast aim", "Precision"]
},

"mice:accessories:mouse-skates": {
  kicker: "Mouse Accessories",
  title: "Mouse Skates",
  copy: "Replacement feet designed to improve glide, consistency and smoothness across different surfaces.",
  meter: 52,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["Smoother glide", "Worn feet", "Custom feel"],
  bestFor: ["Faster glide", "Maintenance", "Customisation"]
},

"mice:accessories:grip-tape": {
  kicker: "Mouse Accessories",
  title: "Grip Tape",
  copy: "Improves mouse grip and handling, especially during long sessions or sweaty conditions.",
  meter: 44,
  scaleLeft: "Comfort",
  scaleRight: "Control",
  meta: ["Better grip", "Sweat control", "Comfort"],
  bestFor: ["Grip", "Control", "Long sessions"]
},

"mice:accessories:arm-sleeves": {
  kicker: "Mouse Accessories",
  title: "Arm Sleeves",
  copy: "Reduces friction between your arm and mousepad for smoother tracking and more consistent movement.",
  meter: 72,
  scaleLeft: "Comfort",
  scaleRight: "Performance",
  meta: ["Less friction", "Smooth tracking", "Consistency"],
  bestFor: ["Tracking", "Glass pads", "Low friction"]
},

"mice:accessories:dongles": {
  kicker: "Mouse Accessories",
  title: "Wireless Dongles",
  copy: "Receivers and polling accessories designed to improve wireless performance and responsiveness.",
  meter: 82,
  scaleLeft: "Standard",
  scaleRight: "Advanced",
  meta: ["Wireless tech", "Polling support", "Low latency"],
  bestFor: ["4K polling", "Competitive", "Wireless mice"]
},

"mice:accessories:bungees": {
  kicker: "Mouse Accessories",
  title: "Mouse Bungees",
  copy: "Holds your mouse cable in place to reduce drag and create a cleaner wired experience.",
  meter: 36,
  scaleLeft: "Simple",
  scaleRight: "Optimised",
  meta: ["Cable control", "Less drag", "Cleaner setup"],
  bestFor: ["Wired mice", "Consistency", "Competitive play"]
},
"mouse-skates:glide:control": {
  kicker: "Skate Glide",
  title: "Control",
  copy: "More controlled glide with extra stopping power. Best if you want precision over raw speed.",
  meter: 28,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["Stopping power", "Precision", "Controlled"],
  bestFor: ["Tac FPS", "Control pads", "Precision"]
},

"mouse-skates:glide:speed": {
  kicker: "Skate Glide",
  title: "Speed",
  copy: "Faster glide with less resistance. Best for tracking, fast corrections and low-friction setups.",
  meter: 84,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["Fast glide", "Low friction", "Tracking"],
  bestFor: ["Speed pads", "Tracking", "Fast aim"]
},

"mouse-skates:glide:balanced": {
  kicker: "Skate Glide",
  title: "Balanced",
  copy: "A safe middle ground between speed and stopping power. Good for most players and most surfaces.",
  meter: 55,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["All-round", "Versatile", "Safe pick"],
  bestFor: ["Mixed games", "Daily use", "Most setups"]
},

"mouse-skates:material:ptfe": {
  kicker: "Skate Material",
  title: "PTFE",
  copy: "The standard choice for smooth, consistent mouse glide. Reliable across most cloth and hybrid pads.",
  meter: 46,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["Smooth", "Reliable", "Popular"],
  bestFor: ["Most pads", "Consistency", "Daily use"]
},

"mouse-skates:material:glass": {
  kicker: "Skate Material",
  title: "Glass",
  copy: "Very fast and durable with a harder feel. Best for players chasing low-friction glide.",
  meter: 92,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["Very fast", "Durable", "Hard feel"],
  bestFor: ["Speed", "Tracking", "Low friction"]
},

"mouse-skates:material:pom": {
  kicker: "Skate Material",
  title: "POM",
  copy: "A slick alternative to PTFE with a smooth glide profile and durable feel.",
  meter: 62,
  scaleLeft: "Control",
  scaleRight: "Speed",
  meta: ["Smooth glide", "Durable", "Alternative feel"],
  bestFor: ["Smoothness", "Speed", "Custom feel"]
},

"mouse-grips:popular-colours:black": {
  kicker: "Grip Colour",
  title: "Black",
  copy: "A clean, low-profile colour that works with most mouse designs and hides wear well.",
  meter: 32,
  scaleLeft: "Subtle",
  scaleRight: "Loud",
  meta: ["Clean look", "Popular", "Easy match"],
  bestFor: ["Stealth setups", "Most mice", "Simple style"]
},

"mouse-grips:popular-colours:white": {
  kicker: "Grip Colour",
  title: "White",
  copy: "A brighter finish for lighter mice or contrast builds. Looks sharp but may show dirt sooner.",
  meter: 42,
  scaleLeft: "Subtle",
  scaleRight: "Loud",
  meta: ["Clean setup", "Contrast", "Bright finish"],
  bestFor: ["White mice", "Contrast", "Minimal setups"]
},

"mouse-grips:popular-colours:red": {
  kicker: "Grip Colour",
  title: "Red",
  copy: "A high-impact colour for more aggressive or themed setups.",
  meter: 78,
  scaleLeft: "Subtle",
  scaleRight: "Loud",
  meta: ["Bold", "Themed", "High contrast"],
  bestFor: ["Accent builds", "Red setups", "Statement look"]
},

"mouse-grips:popular-colours:blue": {
  kicker: "Grip Colour",
  title: "Blue",
  copy: "A strong accent colour that pairs well with blue, white, black or esports-style setups.",
  meter: 68,
  scaleLeft: "Subtle",
  scaleRight: "Loud",
  meta: ["Accent colour", "Cool tone", "Setup match"],
  bestFor: ["Blue setups", "Contrast", "Custom style"]
},

"mouse-grips:popular-colours:pink": {
  kicker: "Grip Colour",
  title: "Pink",
  copy: "A bright accent option for custom setups, themed mice and standout builds.",
  meter: 82,
  scaleLeft: "Subtle",
  scaleRight: "Loud",
  meta: ["Bright", "Custom", "Statement"],
  bestFor: ["Themed builds", "Accent setups", "Custom look"]
},

"mouse-grips:popular-colours:purple": {
  kicker: "Grip Colour",
  title: "Purple",
  copy: "A distinctive accent colour that works well with darker mice and RGB-heavy setups.",
  meter: 74,
  scaleLeft: "Subtle",
  scaleRight: "Loud",
  meta: ["Distinctive", "RGB setups", "Accent"],
  bestFor: ["Purple setups", "Dark mice", "Custom builds"]
},

"mouse-grips:material:polymer-rubber": {
  kicker: "Grip Material",
  title: "Polymer Rubber",
  copy: "A tackier grip material focused on control, hold and secure mouse handling.",
  meter: 82,
  scaleLeft: "Smooth",
  scaleRight: "Tacky",
  meta: ["High grip", "Control", "Secure feel"],
  bestFor: ["Sweaty hands", "Control", "FPS"]
},

"mouse-grips:material:poron": {
  kicker: "Grip Material",
  title: "Poron",
  copy: "A softer cushioning material with a comfortable feel and light pressure absorption.",
  meter: 72,
  scaleLeft: "Firm",
  scaleRight: "Soft",
  meta: ["Comfort", "Soft feel", "Cushioned"],
  bestFor: ["Comfort", "Long sessions", "Soft touch"]
},

"mouse-grips:material:fabric": {
  kicker: "Grip Material",
  title: "Fabric",
  copy: "A cloth-like grip texture that can feel softer and less rubbery in the hand.",
  meter: 78,
  scaleLeft: "Rubbery",
  scaleRight: "Textile",
  meta: ["Textile feel", "Soft touch", "Less rubbery"],
  bestFor: ["Comfort", "Texture", "Daily use"]
},
"keyboards:layout:full-size-uk": {
  kicker: "Keyboard Layout",
  title: "Full Size",
  copy: "Includes the full key cluster and numpad. Best if you need maximum functionality and desk space is not an issue.",
  meter: 95,
  scaleLeft: "Compact",
  scaleRight: "Full-size",
  meta: ["Numpad", "Full layout", "Productivity"],
  bestFor: ["Work", "Data entry", "Full control"]
},

"keyboards:layout:tenkeyless": {
  kicker: "Keyboard Layout",
  title: "TenKeyLess",
  copy: "Removes the numpad while keeping the main keyboard and function row. A strong gaming-focused layout.",
  meter: 76,
  scaleLeft: "Compact",
  scaleRight: "Full-size",
  meta: ["No numpad", "More mouse room", "Popular"],
  bestFor: ["FPS", "Gaming", "Desk space"]
},

"keyboards:layout:75": {
  kicker: "Keyboard Layout",
  title: "75%",
  copy: "A compact layout that keeps function keys and arrows while saving more space than TKL.",
  meter: 58,
  scaleLeft: "Compact",
  scaleRight: "Full-size",
  meta: ["Compact", "Function row", "Efficient"],
  bestFor: ["Gaming", "Typing", "Small desks"]
},

"keyboards:layout:65": {
  kicker: "Keyboard Layout",
  title: "65%",
  copy: "Removes the function row but keeps arrow keys. Good for compact gaming setups without going ultra-minimal.",
  meter: 42,
  scaleLeft: "Compact",
  scaleRight: "Full-size",
  meta: ["Compact", "Arrow keys", "Clean setup"],
  bestFor: ["Small desks", "Gaming", "Minimal setup"]
},

"keyboards:layout:60": {
  kicker: "Keyboard Layout",
  title: "60%",
  copy: "Very compact layout with fewer dedicated keys. Best for maximum mouse room and minimalist setups.",
  meter: 25,
  scaleLeft: "Compact",
  scaleRight: "Full-size",
  meta: ["Very compact", "More mouse space", "Minimal"],
  bestFor: ["FPS", "Travel", "Minimal desks"]
},

"keyboards:switches:linear": {
  kicker: "Switch Type",
  title: "Linear",
  copy: "Smooth keypress with no tactile bump. Popular for fast gaming and rapid repeated inputs.",
  meter: 22,
  scaleLeft: "Quiet",
  scaleRight: "Feedback",
  meta: ["Smooth press", "Fast", "Popular"],
  bestFor: ["Gaming", "Rapid inputs", "FPS"]
},

"keyboards:switches:tactile": {
  kicker: "Switch Type",
  title: "Tactile",
  copy: "Adds a noticeable bump during the keypress. Good for typing feedback without the loud click.",
  meter: 58,
  scaleLeft: "Quiet",
  scaleRight: "Feedback",
  meta: ["Bump feel", "Typing", "Controlled"],
  bestFor: ["Typing", "Mixed use", "Feedback"]
},

"keyboards:switches:clicky": {
  kicker: "Switch Type",
  title: "Clicky",
  copy: "Tactile feedback with an audible click. Great if you like sound and feedback, less ideal for shared spaces.",
  meter: 88,
  scaleLeft: "Quiet",
  scaleRight: "Feedback",
  meta: ["Audible click", "Feedback", "Classic feel"],
  bestFor: ["Typing", "Feedback", "Solo setups"]
},

"keyboards:switches:optical": {
  kicker: "Switch Type",
  title: "Optical",
  copy: "Uses light-based actuation for fast response and durability. Often found in performance-focused boards.",
  meter: 86,
  scaleLeft: "Standard",
  scaleRight: "Performance",
  meta: ["Fast actuation", "Durable", "Performance"],
  bestFor: ["Competitive", "Fast inputs", "Gaming"]
},

"keyboards:switches:membrane": {
  kicker: "Switch Type",
  title: "Membrane",
  copy: "Softer, quieter key feel compared with mechanical switches. Usually more budget-friendly.",
  meter: 28,
  scaleLeft: "Budget",
  scaleRight: "Performance",
  meta: ["Quiet", "Soft feel", "Accessible"],
  bestFor: ["Casual use", "Quiet setups", "Budget"]
},

"keyboards:accessories:keycaps": {
  kicker: "Keyboard Accessories",
  title: "Keycaps",
  copy: "Change the look, feel and sound profile of your keyboard with different profiles, materials and designs.",
  meter: 62,
  scaleLeft: "Utility",
  scaleRight: "Customisation",
  meta: ["Style", "Feel", "Sound"],
  bestFor: ["Custom builds", "Aesthetics", "Feel tuning"]
},

"keyboards:accessories:wrist-rests": {
  kicker: "Keyboard Accessories",
  title: "Wrist Rests",
  copy: "Adds wrist support and comfort for longer typing or gaming sessions.",
  meter: 72,
  scaleLeft: "Minimal",
  scaleRight: "Comfort",
  meta: ["Support", "Comfort", "Long sessions"],
  bestFor: ["Typing", "Long sessions", "Desk comfort"]
},

"keyboards:accessories:usb-type-c-cables": {
  kicker: "Keyboard Accessories",
  title: "USB-C Cables",
  copy: "Replacement or custom cables for cleaner setups, better routing and keyboard compatibility.",
  meter: 58,
  scaleLeft: "Utility",
  scaleRight: "Customisation",
  meta: ["Cable routing", "Setup style", "Compatibility"],
  bestFor: ["Clean setups", "Custom builds", "Replacement"]
},

"keyboards:accessories:shrouds": {
  kicker: "Keyboard Accessories",
  title: "Shrouds",
  copy: "Visual and protective add-ons used to change the keyboard’s appearance or build style.",
  meter: 66,
  scaleLeft: "Utility",
  scaleRight: "Customisation",
  meta: ["Style", "Protection", "Custom look"],
  bestFor: ["Customisation", "Aesthetics", "Build themes"]
},
"audio:headsets:wired": {
  kicker: "Headset Type",
  title: "Wired",
  copy: "Simple plug-in connection with no charging. Best for reliable audio and low-maintenance setups.",
  meter: 82,
  scaleLeft: "Convenience",
  scaleRight: "Reliability",
  meta: ["No charging", "Reliable", "Simple"],
  bestFor: ["Gaming", "Desk setups", "Low maintenance"]
},

"audio:headsets:wireless": {
  kicker: "Headset Type",
  title: "Wireless",
  copy: "Cable-free audio for cleaner setups and more movement freedom, usually with battery charging required.",
  meter: 72,
  scaleLeft: "Reliability",
  scaleRight: "Freedom",
  meta: ["Cable-free", "Clean setup", "Comfort"],
  bestFor: ["Console", "Casual gaming", "Clean desks"]
},

"audio:headsets:surround-sound": {
  kicker: "Headset Feature",
  title: "Surround Sound",
  copy: "Virtual surround processing can help with immersion and positional cues, depending on game and tuning.",
  meter: 76,
  scaleLeft: "Stereo",
  scaleRight: "Immersive",
  meta: ["Positional audio", "Immersion", "Game audio"],
  bestFor: ["FPS", "Story games", "Immersion"]
},

"audio:headsets:3-5mm-jack": {
  kicker: "Connection Type",
  title: "3.5mm Jack",
  copy: "Universal analogue connection for PCs, controllers, handhelds and many audio devices.",
  meter: 44,
  scaleLeft: "Specialised",
  scaleRight: "Universal",
  meta: ["Analogue", "Controller-ready", "Flexible"],
  bestFor: ["Console", "Controllers", "Multi-device"]
},

"audio:headsets:usb": {
  kicker: "Connection Type",
  title: "USB",
  copy: "Digital connection often used for PC headsets, built-in sound processing and plug-and-play setups.",
  meter: 62,
  scaleLeft: "Analogue",
  scaleRight: "Digital",
  meta: ["Plug-and-play", "PC audio", "Digital"],
  bestFor: ["PC gaming", "Desk setups", "Simple install"]
},

"audio:audio:earphones": {
  kicker: "Audio Type",
  title: "Earphones",
  copy: "Lightweight in-ear audio for minimal setups, travel or players who prefer less headset bulk.",
  meter: 34,
  scaleLeft: "Minimal",
  scaleRight: "Immersive",
  meta: ["Lightweight", "Portable", "Low bulk"],
  bestFor: ["Travel", "Minimal setups", "Console"]
},

"audio:audio:microphones": {
  kicker: "Audio Type",
  title: "Microphones",
  copy: "Dedicated microphones improve voice clarity for streaming, calls and team communication.",
  meter: 82,
  scaleLeft: "Basic comms",
  scaleRight: "Voice quality",
  meta: ["Clear voice", "Streaming", "Comms"],
  bestFor: ["Streaming", "Discord", "Content"]
},

"audio:accessories:headset-stands": {
  kicker: "Audio Accessory",
  title: "Headset Stands",
  copy: "Keeps your headset stored cleanly and helps tidy the desk when not in use.",
  meter: 58,
  scaleLeft: "Utility",
  scaleRight: "Setup polish",
  meta: ["Desk tidy", "Storage", "Display"],
  bestFor: ["Clean desks", "Setup style", "Storage"]
},

"audio:accessories:kitty-ears": {
  kicker: "Audio Accessory",
  title: "Kitty Ears",
  copy: "A visual accessory for headset customisation and themed setups.",
  meter: 86,
  scaleLeft: "Utility",
  scaleRight: "Style",
  meta: ["Custom look", "Fun", "Themed"],
  bestFor: ["Style", "Streaming", "Custom setups"]
},

"console:controllers:wired": {
  kicker: "Controller Type",
  title: "Wired Controllers",
  copy: "Reliable low-latency connection with no charging required. Popular for competitive console play.",
  meter: 82,
  scaleLeft: "Freedom",
  scaleRight: "Consistency",
  meta: ["Low latency", "Reliable", "No charging"],
  bestFor: ["Competitive", "Console desks", "Consistency"]
},

"console:controllers:wireless": {
  kicker: "Controller Type",
  title: "Wireless Controllers",
  copy: "Cable-free play with more comfort and flexibility for sofa, handheld and casual setups.",
  meter: 34,
  scaleLeft: "Freedom",
  scaleRight: "Consistency",
  meta: ["Cable-free", "Comfort", "Flexible"],
  bestFor: ["Casual gaming", "Living rooms", "Comfort"]
},

"console:controllers:xbox": {
  kicker: "Platform",
  title: "Xbox",
  copy: "Controllers and accessories designed for Xbox compatibility and familiar Xbox-style layouts.",
  meter: 52,
  scaleLeft: "Universal",
  scaleRight: "Platform-specific",
  meta: ["Xbox layout", "Console-ready", "Familiar feel"],
  bestFor: ["Xbox", "PC gaming", "Controller players"]
},

"console:controllers:playstation": {
  kicker: "Platform",
  title: "PlayStation",
  copy: "PlayStation-compatible controllers and accessories with symmetrical stick layouts and console support.",
  meter: 56,
  scaleLeft: "Universal",
  scaleRight: "Platform-specific",
  meta: ["PS layout", "Console-ready", "Symmetrical sticks"],
  bestFor: ["PlayStation", "Console gaming", "Controller comfort"]
},

"console:controllers:mobile": {
  kicker: "Platform",
  title: "Mobile Gaming",
  copy: "Portable controllers and accessories designed for handheld gaming and phone compatibility.",
  meter: 84,
  scaleLeft: "Desktop",
  scaleRight: "Portable",
  meta: ["Portable", "Travel", "Phone gaming"],
  bestFor: ["Mobile gaming", "Travel", "Portable setups"]
},

"console:headsets:wired": {
  kicker: "Console Audio",
  title: "Wired Headsets",
  copy: "Simple plug-and-play audio for controllers, consoles and gaming setups with no charging required.",
  meter: 82,
  scaleLeft: "Freedom",
  scaleRight: "Reliability",
  meta: ["Plug-and-play", "Reliable", "Simple"],
  bestFor: ["Console", "Competitive", "No charging"]
},

"console:headsets:wireless": {
  kicker: "Console Audio",
  title: "Wireless Headsets",
  copy: "Cable-free headset setups for cleaner gaming spaces and more movement freedom.",
  meter: 76,
  scaleLeft: "Reliability",
  scaleRight: "Freedom",
  meta: ["Wireless", "Comfort", "Clean setup"],
  bestFor: ["Console", "Living room", "Casual gaming"]
},

"console:headsets:playstation": {
  kicker: "Platform Audio",
  title: "PlayStation Audio",
  copy: "Gaming audio gear compatible with PlayStation consoles and controllers.",
  meter: 58,
  scaleLeft: "Universal",
  scaleRight: "Platform-specific",
  meta: ["PS support", "Gaming audio", "Console-ready"],
  bestFor: ["PlayStation", "Party chat", "Gaming"]
},

"console:headsets:xbox": {
  kicker: "Platform Audio",
  title: "Xbox Audio",
  copy: "Headsets and audio accessories designed for Xbox gaming and communication.",
  meter: 58,
  scaleLeft: "Universal",
  scaleRight: "Platform-specific",
  meta: ["Xbox support", "Gaming audio", "Console-ready"],
  bestFor: ["Xbox", "Voice chat", "Gaming"]
},

"console:headsets:mobile": {
  kicker: "Portable Audio",
  title: "Mobile Audio",
  copy: "Portable gaming audio solutions designed for handheld and mobile gaming setups.",
  meter: 82,
  scaleLeft: "Desktop",
  scaleRight: "Portable",
  meta: ["Portable", "Travel", "Compact"],
  bestFor: ["Travel", "Mobile gaming", "Portable setups"]
},

"console:controller-grips:all-controller-grips": {
  kicker: "Controller Grip",
  title: "Controller Grips",
  copy: "Improve comfort, grip and handling for longer gaming sessions and sweaty hands.",
  meter: 72,
  scaleLeft: "Comfort",
  scaleRight: "Grip",
  meta: ["Better hold", "Comfort", "Control"],
  bestFor: ["Long sessions", "Competitive", "Sweaty hands"]
}

};

var defaultPreviewData = {
  "Mousepads": {
    kicker: "Gear Guide",
    title: "Hover a spec",
    copy: "Get quick guidance on size, surface, speed, firmness and playstyle before choosing.",
    meter: 58,
    scaleLeft: "Control",
    scaleRight: "Speed",
    meta: ["Fast guidance", "Built for comparison"],
    bestFor: ["FPS", "Competitive", "Control"]
  },

  "Mice": {
    kicker: "Mouse Guide",
    title: "Hover a spec",
    copy: "Learn how weight, grip style, connectivity and accessories affect comfort, speed and aim.",
    meter: 54,
    scaleLeft: "Comfort",
    scaleRight: "Performance",
    meta: ["Grip styles", "Competitive aim"],
    bestFor: ["FPS", "Shape", "Performance"]
  },

  "Keyboards": {
    kicker: "Keyboard Guide",
    title: "Hover a spec",
    copy: "Compare layouts, switch types and accessories to find the right keyboard feel and setup size.",
    meter: 52,
    scaleLeft: "Compact",
    scaleRight: "Full-size",
    meta: ["Layouts", "Switch feel"],
    bestFor: ["Gaming", "Typing", "Desk setup"]
   },

   "Audio": {
    kicker: "Audio Guide",
    title: "Hover a spec",
    copy: "Compare headset connection types, microphones, earphones and audio accessories for your setup.",
    meter: 56,
    scaleLeft: "Simple",
    scaleRight: "Setup",
    meta: ["Headsets", "Mics", "Accessories"],
    bestFor: ["Comms", "Immersion", "Streaming"]
    },

    "Console": {
    kicker: "Console Guide",
    title: "Hover a spec",
    copy: "Browse controllers, console headsets, grips and accessories for PlayStation, Xbox and mobile gaming.",
    meter: 58,
    scaleLeft: "Casual",
    scaleRight: "Competitive",
    meta: ["Controllers", "Headsets", "Accessories"],
    bestFor: ["Console", "Comfort", "Setup upgrades"]
    },

  "Mouse Grips": {
    kicker: "Grip Tape Guide",
    title: "Hover a spec",
    copy: "Choose grip tape by colour, compatibility and material feel before upgrading your mouse.",
    meter: 56,
    scaleLeft: "Comfort",
    scaleRight: "Grip",
    meta: ["Better control", "Mouse fit"],
    bestFor: ["Grip", "Sweat control", "Custom feel"]
    },

  "Mouse Skates": {
    kicker: "Skate Guide",
    title: "Hover a spec",
    copy: "Learn how glide, materials and skate types affect speed, smoothness and control.",
    meter: 62,
    scaleLeft: "Control",
    scaleRight: "Speed",
    meta: ["Glide types", "Surface feel"],
    bestFor: ["Smoothness", "Speed", "Custom glide"]
  }
};

function renderPreview(panel, item) {
  if (!panel || !item) return;

  var kicker = panel.querySelector(".mega-menu__preview-kicker");
  var title = panel.querySelector(".mega-menu__preview-title");
  var copy = panel.querySelector(".mega-menu__preview-copy");
  var meter = panel.querySelector(".mega-menu__preview-meter span");
  var meta = panel.querySelector(".mega-menu__preview-meta");
  var scaleLeft = panel.querySelector("[data-mega-scale-left]");
  var scaleRight = panel.querySelector("[data-mega-scale-right]");
  var bestFor = panel.querySelector("[data-mega-bestfor]");

  panel.classList.remove("is-updating");

  requestAnimationFrame(function () {
    panel.classList.add("is-updating");

    if (kicker) kicker.textContent = item.kicker || "";
    if (title) title.textContent = item.title || "";
    if (copy) copy.textContent = item.copy || "";
    if (meter) meter.style.width = (item.meter || 50) + "%";
    if (scaleLeft) scaleLeft.textContent = item.scaleLeft || "";
    if (scaleRight) scaleRight.textContent = item.scaleRight || "";

    if (bestFor) {
      bestFor.innerHTML = "";
      (item.bestFor || []).forEach(function (label) {
        var span = document.createElement("span");
        span.textContent = label;
        bestFor.appendChild(span);
      });
    }

    if (meta) {
      meta.innerHTML = "";
      (item.meta || []).forEach(function (label) {
        var span = document.createElement("span");
        span.textContent = label;
        meta.appendChild(span);
      });
    }
  });
}

function getPreviewItemForMenu(menu, key) {
  if (!menu) return null;

  var menuTitle = menu.getAttribute("data-mega-menu-title") || "";

  return previewData[key] || defaultPreviewData[menuTitle] || null;
}

function applyDefaultPreview(menu) {
  if (!menu) return;

  var panel = menu.querySelector("[data-mega-preview-panel]");
  var item = getPreviewItemForMenu(menu, "");

  renderPreview(panel, item);
}

document.querySelectorAll(".mega-menu__inner[data-mega-menu-title]").forEach(function (menu) {
  applyDefaultPreview(menu);
});

document.addEventListener("mouseover", function (event) {
  var link = event.target.closest(".mega-menu__link[data-mega-preview-key]");
  if (!link) return;

  var menu = link.closest(".mega-menu__inner");
  var panel = menu ? menu.querySelector("[data-mega-preview-panel]") : null;
  var key = link.getAttribute("data-mega-preview-key");
  var item = getPreviewItemForMenu(menu, key);

  renderPreview(panel, item);
});

document.addEventListener("focusin", function (event) {
  var link = event.target.closest(".mega-menu__link[data-mega-preview-key]");
  if (!link) return;

  var menu = link.closest(".mega-menu__inner");
  var panel = menu ? menu.querySelector("[data-mega-preview-panel]") : null;
  var key = link.getAttribute("data-mega-preview-key");
  var item = getPreviewItemForMenu(menu, key);

  renderPreview(panel, item);
});
})();